import React from "react";

export default function PrivacyPolicyEN() {
  return (
    <div className="min-h-screen">
      <iframe
        src="/privacy-policy.html"
        title="Privacy Policy"
        style={{ width: "100%", height: "100vh", border: "0" }}
      />
    </div>
  );
}
